import {
  GOOGLE_CHARTS_REQUEST,
  GOOGLE_CHARTS_SUCCESS,
  GOOGLE_CHARTS_FAILURE,
} from "./googleChartsType";
const initialState = {
  success: false,
  loading: false,
  chartData: [],
  error: "",
};
const googleChartsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GOOGLE_CHARTS_REQUEST:
      return {
        ...state,
        success: false,
        loading: action.loading,
      };
    case GOOGLE_CHARTS_SUCCESS:
      const setSignUpState = {
        ...state,
        success: true,
        loading: action.loading,
        chartData: action.payload,
        error: "",
      };
      return setSignUpState;
    case GOOGLE_CHARTS_FAILURE:
      return {
        ...state,
        success: false,
        loading: action.loading,
        chartData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default googleChartsReducer;
